import React, { useState, useEffect } from 'react';
import ProductionUpsert from './NewProduction';
import LoadCastFile from '../UploadCast';
import { CommonUtilities } from 'commonUtils';

export default function ProductionLanding(subEntity: any) {


    let [productionCount, SetProductionCount] = useState(0);
    let [loadCast, SetloadCast] = useState(false);
    let [productionUpsert, SetProductionUpsert] = useState(false);
    let [productionSelected, SetProductionSelected] = useState<any>([]);

    const productionUpsertChange = (e: any) => {
        productionUpsert = false
        SetProductionUpsert(productionUpsert)

        if (e == "saved") {
            CommonUtilities.showToastDawer('Production created successfully', 'Success')
        }
    }
    const LoadCastFileChange = (e: any) => {
        loadCast = false
        SetloadCast(loadCast)
    }


    let [yearOption, SetYearOption] = useState<any>([]);
    useEffect(() => {
        const startYear = 1990;
        const currentYear = new Date().getFullYear();

        const years = Array.from(
            { length: currentYear - startYear + 1 },
            (_, i) => currentYear - i
        );

        console.log(years)

        yearOption = years;
        SetYearOption(yearOption)
        console.log(yearOption)
    }, [])

    const Production = [
        {
            productionTitle: "Silent Streets – Series 2, Episode 3",
            productionUrl: "/productions/PROD-UK-SS-S2E3-0001",
            productionId: "PROD-UK-SS-S2E3-0001",
            programmeNumber: "S2E3",
            producerBroadcaster: ["BBC", "ITV", "Channel 4"],
            type: "TV Series",
            year: 2025,
            status: "Active",
            lastUpdated: "2025-03-25"
        }
    ]

    let [searchFor, SetSearch] = useState("");
    let [yearSelection, SetyearSelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [ProducerSelection, SetProducerSelection] = useState("");

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        yearSelection = '';
        SetyearSelection(yearSelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        ProducerSelection = '';
        SetProducerSelection(ProducerSelection)
    }

    const changeTabMenu = (e: any) => {
        if (e == "Cue") {
            subEntity.onChangeSelectMenu("Cue")
        }

        if (e == "Cast") {
            subEntity.onChangeSelectMenu("Cast")

        }

    }
    return (<>

        <div className="ws-12 prl">

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>

                    <div className='w-71'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by Production title,ID,Programme Number' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='ml pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All Statuses</option>
                            <option value={'Draft'}> Draft </option>
                            <option value={'Active'}> Active </option>
                            <option value={'Closed'}> Closed  </option>
                            <option value={'Archived'}> Archived  </option>
                        </select>

                        <select className='ml pm pbl height40 width110 grey text-bold center icon-btn info' value={yearSelection} onChange={(e: any) => SetyearSelection(e.target.value)}>
                            <option> All Years</option>
                            {
                                yearOption?.map((vales: any) => {
                                    return (<option value={vales}> {vales}  </option>)
                                })
                            }
                        </select>

                        <select className='ml pm pbl height40 width80 grey text-bold icon-btn info hide' title='Broadcaster/Producer' value={ProducerSelection} onChange={(e: any) => SetProducerSelection(e.target.value)}>
                            <option> All</option>
                        </select>

                        <select className='ml pm pbl height40 width90 white text-bold icon-btn info hide'  >
                            <option> Filter </option>
                        </select>
                    </div>

                    {(searchFor.length > 0 || statusSelection.length > 0 || ProducerSelection.length > 0 || yearSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit height40 mr pull-right" onClick={() => SetProductionUpsert(true)}>New Production</button>

                    <button type="button" className="text-bold icon-btn borderNone noOutline height40 mr pull-right" onClick={() => SetloadCast(true)}>Import <i className='icon-angle-right pll text-l'></i></button>
                </div>
            </div>


            {(searchFor.length > 0 || statusSelection.length > 0 || ProducerSelection.length > 0 || yearSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {ProducerSelection.length > 0 && <>
                        <span className='text-bold mr'>Producer/Broadcast :</span>
                        <span className='mr'>{ProducerSelection}</span>
                    </>}
                    {yearSelection.length > 0 && <>
                        <span className='text-bold mr'>Year :</span>
                        <span className='mr'>{yearSelection}</span>
                    </>}
                </div>

            </div>}

            <div className='ws-12'>

                <table className="newTable box overflowVisible">
                    <thead>
                        <tr>
                            <th >Production Title</th>
                            <th >Production Id</th>
                            <th >Programme Number</th>
                            <th >Producer/Broadcast</th>
                            <th >Type</th>
                            <th >Year</th>
                            <th >Status</th>
                            <th >Last Updated</th>
                            <th >Operations</th>
                        </tr>
                    </thead>
                    <tbody>

                        {Production?.map((values: any) => {
                            return (

                                <tr>
                                    <td className='forceSingleLine'> {values?.productionTitle}</td>
                                    <td> {values?.productionId}</td>
                                    <td>{values?.programmeNumber}</td>
                                    <td>{values?.producerBroadcaster}</td>
                                    <td>{values?.type}</td>
                                    <td>{values?.year}</td>
                                    <td>{values?.status}</td>
                                    <td>{values?.lastUpdated}</td>
                                    <td className=' '>

                                        <div className=" hover-box text-center ">
                                            <div className="hover-box   text-l text-bold"> ... </div>

                                            <ul className="hover-block rightReset ws-3 pull-right plxl bgTransparent">
                                                <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190  ">View</button> </li>
                                                <li className='pt ws-10 pull-right'><button className="pull-left icon-btn edit width190" onClick={() => { SetProductionUpsert(true); SetProductionSelected(values) }}>Edit</button></li>
                                                <li className='pt ws-10 pull-right'><button className="pull-left icon-btn info width190" onClick={() => changeTabMenu("Cast")}>Manage Cast</button></li>
                                                <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190" onClick={() => changeTabMenu("Cue")}>Manage Cues</button></li>
                                                <li className='pt ws-10 pull-right'> <button className="pull-left icon-btn info width190">Archive</button> </li>
                                            </ul>

                                        </div>

                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                {(productionCount == 0 && Production.length == 0) && <div className='ws-12 box text-center'>

                    <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>

                        <img
                            src="https://cdn-icons-png.flaticon.com/512/1179/1179120.png"
                            alt="No data"
                            className="empty-icon"
                        />

                        <h1 className='text-bold'>No productions yet</h1>
                        <h3 className='text-bold grey'>Create your first production to begin recording casts and cues.</h3>

                        <div className=' ptxl paddingCenterBox'>
                            <button type="button" className="text-bold icon-btn edit paddingCenterBox height40 mr" onClick={() => SetProductionUpsert(true)}>New Production</button>

                            <button type="button" className="text-bold icon-btn info paddingCenterBox height40 mr" onClick={() => SetloadCast(true)}>Import Production</button>
                        </div>
                    </div>


                </div>}

            </div>

            {
                (() => {
                    if (productionUpsert) {
                        return <ProductionUpsert productionUpsertChange={productionUpsertChange} productionUpsertOpen={productionUpsert} productionSelected={productionSelected} />
                    }

                    if (loadCast) {
                        return <LoadCastFile LoadCastFileChange={LoadCastFileChange} loadCast={loadCast} />
                    }
                })()
            }
        </div>
    </>)
}